import {ActivatedRoute, ActivatedRouteSnapshot, ActivationStart, Event, Params, Router} from '@angular/router';
import {

    BDModalComponent,
    BDModalService,
    BDShared,
} from '@brother-apps/brother-dealerapp-shared-lib';
import {Component, OnDestroy, OnInit, Optional, ViewChild} from '@angular/core';

import {BDCPConstsService} from '../../../shared/services/consts.service';
import {BDCPShareService} from '../../../shared/services/share.service';
import {IBDCPFolderService} from '../../../shared/services/folder-service/folder.interface';
import {Subscription} from 'rxjs';
import {UtilityService} from '../../../../../../../shared/services/utility.service';

@Component({
    selector: 'bdcp-master-detail-master',
    templateUrl: './master.page.html',
    styleUrls: ['./master.page.scss']
})
export class BDCPMasterDetailMasterComponent implements OnInit, OnDestroy {

    @ViewChild('modal', {static: true}) public modal: BDModalComponent;
    @ViewChild('folderModal', {static: true}) public folderModal: BDModalComponent;


    public newFolderName = '';

    private subscriptions: Subscription[];

    public constructor(
        public consts: BDCPConstsService,
        public share: BDCPShareService,
        public modalService: BDModalService,
        public folderService: IBDCPFolderService,
        private router: Router,
        private route: ActivatedRoute,
        @Optional() private appUtilityService: UtilityService
    ) {
    }

    public ngOnInit(): void {
        this.route.queryParams.subscribe((qp: Params) => {
            for (const key of Object.keys(qp)) {
                if (key === 'user') {
                    const obj = JSON.parse(atob(qp[key]));
                    this.share.sharedModel = <BDShared>obj;

                }
            }

            if (!this.share.sharedModel) {
                this.share.sharedModel = this.appUtilityService?.getUserQueryParamData();
            }
            this.init();

        });

    }

    public ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            if (subscription && !subscription.closed) {
                subscription.unsubscribe();
            }
        }
    }

    public scrollToTop(): void {
        window.scroll(0, 0);
    }

    public async addToFolder(folderId: number): Promise<void> {
        try {
            await this.folderService.addProduct(folderId);
        } catch (ex) {

        } finally {
            this.folderService.close();
        }
    }

    public async addToNewFolder(): Promise<void> {
        try {
            await this.folderService.create(this.newFolderName);
            const folders = await this.folderService.getAll();
            await this.folderService.addProduct(folders.filter(f => f.name === this.newFolderName)[0].id);
        } catch (ex) {

        } finally {
            this.folderService.close();
            this.newFolderName = '';
        }
    }

    public canAddToNewFolder(): boolean {
        return this.newFolderName.trim() !== ''
            && !this.folderService.folders.some(f => f.name.trim().toLowerCase() === this.newFolderName.trim().toLowerCase());
    }

    private init(): void {
        this.modalService.init(this.modal);
        this.folderService.init(this.folderModal);
        this.subscriptions = [];
        this.subscriptions.push(this.router.events.subscribe(e => this.handleRouterEvents(e)));
        this.handleNewPath(this.getPath(this.route));
    }

    private handleRouterEvents(event: Event): void {
        if (event instanceof ActivationStart) {
            this.handleNewPath(this.getPath((<ActivationStart>event).snapshot));
        }
    }

    private handleNewPath(path: string): void {
        this.share.visitedPages.push(path);
    }

    private getPath(route: ActivatedRoute | ActivatedRouteSnapshot): string {
        let child = !route.firstChild ? route : route.firstChild;

        while (child.firstChild) {
            child = child.firstChild;
        }

        let aggregatedPath = '';

        for (const p of child.pathFromRoot) {
            if (!p || !p.routeConfig) {
                continue;
            }
            aggregatedPath += p.routeConfig.path + '/';
        }

        return aggregatedPath.replace(/\/+/g, '/');
    }
}
